/** Query param ao ir para a aba Carreira com o campo de busca pré-preenchido (ex.: vindo do Solo). */
export const CAREER_SEARCH_QUERY_KEY = 'careerSearch';

/** `/?tab=career&careerSearch=…` com codificação segura. */
export function careerHomePathWithSearch(caption: string): string {
  const q = caption.trim();
  const params = new URLSearchParams();
  params.set('tab', 'career');
  if (q) params.set(CAREER_SEARCH_QUERY_KEY, q);
  return `/?${params.toString()}`;
}
